import { Injectable } from '@angular/core';
@Injectable()
export class StoryLink {
    id: number;
    webAddress: string;
    ranking?: number;
}
